import React from 'react';
import '../../styles/Membership.css';


export default function MembershipCategories() {
  return (
    <div className='MemberShipContainer'>
        <div className='benefits-header-container' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/membership_cats_banner.jpg'})`}}>
            <div className='benefits-header-content'>
                <div className='benefits-header-title'>
                    Explore Our Membership Categories
                </div>
                {/* <div className='benefits-header-btn'>
                    REGISTER NOW
                </div> */}
            </div>
        </div>
        
        <div style={{padding: '0 100px', margin: '60px 0'}}>
            <div className='MembershipCatTable'>
                <div className='MembershipCatTableTitle'>Membership Categories</div>

                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>
                        Full Members
                    </div>
                    <div className='MembershipCatTableColumnSecond'>
                        Telecommunication companies or administrations that operate public networks in Caribbean territories, providing national and/or international services.
                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>
                        Affiliate Members
                    </div>
                    <div className='MembershipCatTableColumnSecond'>
                        Service providers, equipment suppliers, government departments, regulatory authorities, consultants, and institutions with a vested interest in Caribbean telecommunications.
                    </div>
                </div>
                <div className='MembershipCatTableRow'>
                    <div className='MembershipCatTableColumnFirst'>
                        Honorary Members
                    </div>
                    <div className='MembershipCatTableColumnSecond'>
                        Individuals who have provided outstanding service to CANTO, invited to join as honorary members without subscription fees.
                    </div>
                </div>
            </div>
        </div>
        
    </div>
  )
}